export const TICKET_OUT = "Ticket Out"

export const TICKET_OUT_PAGES = {
    TABLE: "table",
    SETTINGS: "settings",
}

// Roles allowed to open Ticket Settings (gear icon) and edit the photo
// requirement. Plain ROLE_TICKET_OUT employees must not see the gear.
export const TICKET_SETTINGS_ROLES = [
    'ROLE_OWNER',
    'ROLE_MANAGER',
    'ROLE_MASTER_ADMIN',
    'ROLE_TECH_ADMIN',
];

// Default photo-requirement setting used before the server value loads.
export const DEFAULT_TICKET_PHOTO_SETTING = { enabled: true, thresholdAmount: 250 };

// Quick-preset pills for the Minimum Amount input (spec §3.1).
export const TICKET_THRESHOLD_PRESETS = [250, 300, 400, 500, 1000];

// Max photo size accepted after client-side compression (spec §5).
export const TICKET_PHOTO_MAX_BYTES = 5 * 1024 * 1024;

// tooltip names
export const BACK = 'Back to Menu';

export const TICKET_OUT_FIELDS = [
  {},
  { id: 'machine', label: 'Machine', align: 'left' },
  { id: 'ticketOut', label: 'Ticket Out', align: 'left' },
  { id: 'time', label: 'Time', align: 'left' },
  { id: 'photo', label: 'Photo', align: 'center' },
  {},
];


export const BONUS_FIELDS = [
    {},
    {id: 'name', label: 'Name', align: "left"},
    {id: 'bonusName', label: 'Bonus Name', align: "left"},
    {id: 'bonusAmount', label: 'Bonus Amount', align: "left"},
    {}
]


export const CUSTOMER_BONUS_FIELDS = [
    {id: 'firstName', label: 'First Name', align: "center"},
    {id: 'lastName', label: 'Last Name', align: "center"},
    {id: 'tagId', label: 'Tag Id', align: "center"},

]